import axios from 'axios'
import router from '@/router'
import { useAuthStore } from '@/store/auth.module'
import { useUiStore } from '@/store/useUiStore'
import { useToast } from '@/composables/useToast'

const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL

// 인터셉터 부착 — v1/v2 인스턴스가 동일 인증/로딩/에러 처리를 공유
const attachInterceptors = instance => {
  instance.interceptors.request.use(
    config => {
      const uiStore = useUiStore()
      uiStore.showLoading()
      const user = JSON.parse(localStorage.getItem('user'))
      if (user && user.accessToken) {
        config.headers['Authorization'] = 'Bearer ' + user.accessToken
      }
      return config
    },
    error => {
      validateSession(error)
      return Promise.reject(error)
    }
  )
  instance.interceptors.response.use(
    config => {
      const uiStore = useUiStore()
      uiStore.hideLoading()
      return config
    },
    error => {
      validateSession(error)
      return Promise.reject(error)
    }
  )
  return instance
}

// v1 (기존) — baseURL .../v1
const apiClient = attachInterceptors(
  axios.create({
    baseURL: `${VUE_APP_API_BASE_URL}/v1`,
    headers: { 'Content-Type': 'application/json' },
  })
)

// v2 (서버 페이징 등 신규) — baseURL .../v2
const apiClientV2 = attachInterceptors(
  axios.create({
    baseURL: `${VUE_APP_API_BASE_URL}/v2`,
    headers: { 'Content-Type': 'application/json' },
  })
)

const validateSession = error => {
  const uiStore = useUiStore()
  const toast = useToast()
  const authStore = useAuthStore()

  uiStore.hideLoading()
  const response = error.response

  if (!response) {
    // 네트워크 에러 또는 서버 무응답
    toast.error('network_error')
    return
  }

  const status = response.status
  const data = response.data
  console.log('response', status, data)

  if (status === 401) {
    // 인증 실패 - 로그인 필요
    toast.loginRequired()
    authStore.logout()
    setTimeout(() => {
      router.push('/').then(() => location.reload())
    }, 2000) // 토스트를 본 후 이동
  } else if (status === 403) {
    // 권한 없음 - 접근 차단
    const userMessage = data.userMessage || data.message || '권한이 없습니다.'
    toast.accessDenied(userMessage)
    // 403은 메인으로 이동하지 않고 사용자가 다른 메뉴 선택 가능
  } else if (status === 404) {
    // 리소스 또는 페이지를 찾을 수 없음
    toast.warning('요청하신 리소스를 찾을 수 없습니다.')
  } else if (status === 422) {
    // 입력 데이터 유효성 오류
    const errorMsg = data.message || '입력하신 데이터에 오류가 있습니다.'
    toast.warning(errorMsg)
  } else if (status >= 500) {
    // 서버 내부 에러 (500, 502, 503, 504)
    toast.error('internal_server_error')
  } else if (data && data.message) {
    // 기타 에러 메시지 (서버의 userMessage 우선 사용)
    const userMessage = data.userMessage || data.message
    toast.error(userMessage)
  } else if (typeof data === 'string') {
    toast.error(data)
  } else {
    // 알 수 없는 에러
    toast.error('알 수 없는 오류가 발생했습니다.')
  }
}
export { apiClient, apiClientV2 }
